import { FieldTypeName } from '@/types/fields'
import { textInputFieldTypes, timeFieldTypes } from './field'

export function notNull<T>(val: T | null): val is T {
  return val !== null
}

export function isValidUUID(value?: string) {
  if (!value) return false

  const uuidPattern =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

  return uuidPattern.test(value)
}

type TimeFieldType = 'datetime' | 'time' | 'date'
export function isTimeFieldType(type: FieldTypeName): type is TimeFieldType {
  return timeFieldTypes.includes(type)
}

export function isTextInputFieldType(type: FieldTypeName) {
  return textInputFieldTypes.includes(type)
}
